<template>
  <div>
    <div class="css-grid battery-order-form__row battery-order-form__row--header">
      <div></div>
      <div class="battery-order-view__cell battery-order-view__cell--header">Billing Info</div>
      <div></div>
    </div>

    <div class="panel">
      <div class="css-grid battery-order-form__row">
        <div></div>
        <div>
          <div class="form__item--row">
            <StoreConnectedSelect :store="store" name="paymentType" :options="paymentOptions" placeholder="Select Payment Option"></StoreConnectedSelect>
          </div>
        </div>
        <div></div>
      </div>
      <CreditCardForm v-if="showCreditCardForm"></CreditCardForm>
    </div>

    <div class="battery-store__unmet-minimum h-helper-text h-center-align" v-if="hasPowerOne && !meetsCartonMinimum">There is a 10 carton minimum purchase requirement for Power One orders</div>
    <div class="battery-store__nav-row h-center-align">
      <button class="btn btn-primary" @click.prevent="nextStep" :disabled="!isFormValid || !isOrderValid">Submit Order</button>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import StoreConnectedSelect from '../form-items/StoreConnectedSelect.vue';
  import StoreConnectedInput from '../form-items/StoreConnectedInput.vue'
  import CreditCardForm from './payment/CreditCardForm.vue';

  export default {
    name: 'PaymentView',
    components: {
      StoreConnectedInput,
      StoreConnectedSelect,
      CreditCardForm,
    },
    data() {
      return {
        store: 'batteryStore',
      };
    },
    computed: {
      ...mapGetters('batteryStore', ['paymentOptions', 'paymentType', 'paymentInfo', 'orderProducts']),
      hasPowerOne() {
        return this.powerOneProducts.length > 0;
      },
      powerOneProducts() {
        return lodash.filter(this.orderProducts, product => product.battery_line === 'Power One');
      },
      meetsCartonMinimum() {
        return lodash.reduce(this.powerOneProducts, (sum, product) => parseInt(product.quantity) + sum, 0) > 1;
      },
      isOrderValid() {
        return this.hasPowerOne ? this.meetsCartonMinimum : this.orderProducts.length > 0;
      },
      showCreditCardForm() {
        return this.paymentType === 'Credit Card';
      },
      isFormValid() {
        if (this.showCreditCardForm) {
          if (this.paymentInfo.cardholderName === null || this.paymentInfo.cardholderName === '') {
            return false;
          }
          if (this.paymentInfo.cardNumber === null || this.paymentInfo.cardNumber === '') {
            return false;
          }
          if (this.paymentInfo.expDate === null || this.paymentInfo.expDate === '') {
            return false;
          }
          if (this.paymentInfo.cvv === null || this.paymentInfo.cvv === '') {
            return false;
          }
        }
        return true;
      },
    },
    methods: {
      nextStep() {
        this.$store.dispatch('batteryStore/submitOrder');
      },
    },
  }
</script>
